
export default async function getBlogs() {
    try {
        const response = await fetch('/api/blogs.json');
        const result = await response.json();

        return result.docs;
    } catch (error) {
        console.error('Failed to load blogs:', error);
        throw error;
    }
}

export async function getBlog(blogId) {
    try {
        const blogs = await getBlogs();
        const blog = blogs.find(blog => blog.id === blogId);

        blog.posts.docs.map(post => {
            post.url =  '/' + blog.slug + '/posts/' + post.slug;
        });

        return blog;
    } catch (error) {
        console.error('Failed to retrieve blog:', error);
        throw error;
    }
}
